export const SELLER_PAGE_SIGNING_TRIGGER_IDS = {
    CONTACT_SELLER: 'Contact Seller',
};

export const SELLER_PAGE_SIGNING_TRIGGER_PLACEMENTS = {
    SELLER_CONTACT_CARD: 'Seller Contact Card',
    SELLER_STICKY_HEADER: 'Seller Sticky Header',
};
